"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Warning = Warning;
var _react = _interopRequireDefault(require("react"));
var _useThemeContext = require("../../hooks/useThemeContext");
function Warning(props) {
  var theme = (0, _useThemeContext.useThemeContext)();
  return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: theme.colors.warning['30'],
    cx: "8",
    cy: "8",
    r: "8"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: theme.colors.neutral['0'],
    strokeWidth: "2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 3.333v5.834M8 10.625v1.75-1.75z"
  }))));
}
//# sourceMappingURL=Warning.js.map